var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-wrapper" }, [
    _c("div", { staticClass: "footer-content" }, [
      _c("div", { staticClass: "right" }, [
        _c(
          "span",
          {
            staticClass: "code-text",
            on: { mouseover: _vm.showQrcode, mouseleave: _vm.hideQrcode }
          },
          [
            _c("i", { staticClass: "icon-erweima" }),
            _vm._v("扫码下载会生意App\n        "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCode,
                    expression: "showCode"
                  }
                ],
                staticClass: "qrcodeBox"
              },
              [
                _c("img", {
                  attrs: { src: require("../assets/images/qrcode.png") }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "javascript:;", target: "_blank", download: false },
            on: { click: _vm.toPrivacy }
          },
          [_vm._v("隐私政策")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("如有问题请发邮件至it@tupperware.com")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48ebb3b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ebb3b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/footer.vue
// module id = null
// module chunks = 